import { render, staticRenderFns } from "./skin.vue?vue&type=template&id=2c9b8c12&scoped=true&"
import script from "./skin.vue?vue&type=script&lang=js&"
export * from "./skin.vue?vue&type=script&lang=js&"
import style0 from "./skin.vue?vue&type=style&index=0&id=2c9b8c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b8c12",
  null
  
)

export default component.exports